import React from "react";
import LocationListings from "../../Components/Location/LocationListings";
import LocationBreadCrumb from "../../Components/Location/LocationBreadCrumb";
import LocationCard from "../../Components/Location/LocationCard";

export default function LocationListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <LocationBreadCrumb />
        <LocationCard />
        {/* <LocationListings /> */}
      </div>
    </React.Fragment>
  );
}
